import { Box, IconButton, Menu, Stack, Typography, useMediaQuery } from '@mui/material'
import { SideBox, MenuListProps, MenuPaperProps, MainBox, SearchStack, StackStyle, TextFieldBox, TypTitle } from './style';
import { useState } from 'react';
import { FilterListRoundedIcon } from '../../icons/FilterListRoundedIcon';
import { PureLightTheme } from '../../styles/theme';
import { COLORS } from '../../styles/variables';

type PageLayoutProps = {
    title: string
    mainComponent: React.ReactNode
    sideComponent?: React.ReactNode
    searchComponent?: React.ReactNode
    topComponent?: React.ReactNode
    titleAside?: React.ReactNode
}

export const PageLayout = ({title, mainComponent, sideComponent, searchComponent, topComponent, titleAside}: PageLayoutProps) => {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('md'));
  const isTitleAsideStacked = useMediaQuery(PureLightTheme.breakpoints.down('lg'));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  
  const handleOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)
  return (
    <Stack direction='row' sx={StackStyle}>
      <Box sx={MainBox}>
        <Stack
          direction="row"
          alignItems="baseline"
          justifyContent="space-between"
          flexWrap="wrap"
          gap={1}
          sx={
            titleAside
              ? {
                  [PureLightTheme.breakpoints.down('lg')]: {
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 0.75,
                    mb: 1.5,
                  },
                }
              : undefined
          }
        >
          <Typography
            variant='h1'
            sx={[
              TypTitle,
              ...(titleAside
                ? [
                    {
                      [PureLightTheme.breakpoints.down('lg')]: {
                        mb: 0.75,
                      },
                    },
                  ]
                : []),
            ]}
          >
            {title}
          </Typography>
          {titleAside ? (
            <Box
              sx={{
                flexShrink: 0,
                width: { xs: '100%', lg: 'auto' },
              }}
            >
              {titleAside}
            </Box>
          ) : null}
        </Stack>
        {topComponent && (
          <Box mb={titleAside && isTitleAsideStacked ? 1.5 : 2}>
            {topComponent}
          </Box>
        )}
        {isMobile && searchComponent && (
          <>
            <Stack 
              direction="row" 
              alignItems="center" 
              sx={SearchStack}
            >
              <Box sx={TextFieldBox}>
                {searchComponent}
              </Box>
              <IconButton onClick={handleOpen} sx={{ padding: "4px" }}>
                <FilterListRoundedIcon sx={{ width: "28px", height: "28px", color: COLORS.CERULEAN }} />
              </IconButton>
            </Stack>

            <Menu
              keepMounted
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              slotProps={{
                paper: { sx: MenuPaperProps },
                list: { sx: MenuListProps },
              }}
            >
              {sideComponent}
            </Menu>
          </>
        )}
        
        {mainComponent}
      </Box>

      {!isMobile && (
        <Box sx={SideBox}>
          {sideComponent}
        </Box>
      )}
    </Stack>
  )
}
